var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgChevronRight = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6464 7.64645C10.8417 7.45118 11.1583 7.45118 11.3536 7.64645L17.3536 13.6464C17.5488 13.8417 17.5488 14.1583 17.3536 14.3536L11.3536 20.3536C11.1583 20.5488 10.8417 20.5488 10.6464 20.3536C10.4512 20.1583 10.4512 19.8417 10.6464 19.6464L16.2929 14L10.6464 8.35355C10.4512 8.15829 10.4512 7.84171 10.6464 7.64645Z",
    fill: "#121212"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChevronRight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/chevron-right.2801d8b9.svg";
export { ForwardRef as ReactComponent };